import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
//  import profileImage from "profile.png";
import { FaPhoneAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";


const OrderDetail = () => {
  const [lead, setLead] = useState(null);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();




  const idToFetch = id;

  useEffect(() => {
    const fetchLeadData = async () => {
      setLoading(true);
      try {
        const response = await fetch("/server/dealer_backend/getAllAccounts"); // Replace with actual backend URL
        const data = await response.json();
        console.log(data);

        if (data.status === "success") {
          const filteredLead = data.data.find((item) => item.id === idToFetch);
          setLead(filteredLead);
        } else {
          console.error("Error fetching data:", data.error);
        }
      } catch (error) {
        console.error("Failed to fetch account data:", error);
      }finally {
        setLoading(false);
      }
    };

    fetchLeadData();
  }, []);

 









  const LeadField = ({ label, value, icon }) => (
    <div className="form-group-field2">
      <label>{label}</label>
      <span>
        {icon && <span className="icon">{icon}</span>}
        {value || "—"}
      </span>
    </div>
  );
  const handleEditClick = async () => {
    navigate(`/account-edit/${idToFetch}`);
  };

  const handleTaskClick = async () => {
    navigate(`/create-task`);
  };






  return (

    loading ? (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500"></div>
      </div>
    ) : (

      <div className="lead-container">
        {/* Lead Status Card */}
        

      


      

        {/* Lead Information Card */}
        <div className="lead-profile-container">
          {lead ? (
            <div className="lead-cards">
              {/* Left Card */}
              <div className="lead-card">
                <div className="form-group-field">
                  <label>Account Owner</label>
                  <span className="email-link">{lead.Account_Name || "—"}</span>
                </div>

                <div className="form-group-field">
                  <label>Industry</label>
                  <span>{lead.Industry || "—"}</span>
                </div>

                <div className="form-group-field">
                  <label>Employees</label>
                  <span>{lead.Employees || "—"}</span>
                </div>

                <div className="form-group-field">
                  <label>Annual Revenue</label>
                  <span>{lead.Annual_Revenue || "—"}</span>
                </div>

                <div className="form-group-field">
                  <label>Phone</label>
                  <span>{lead.Phone || "—"}</span>
                </div>
              </div>
            </div>

          ) : (
            <p className="loading-text">Loading account details...</p>
          )}
        </div>


        <div className="lead-container2">
          <h3 className="lead-title">Account Information</h3>
          <hr className="lead-divider" />
          {lead && (
            <div className="lead-details">
              {/* Left Column */}
              <div className="lead-column">
                {/* <LeadField label="Account Owner" value={lead?.Owner} /> */}
                <LeadField label="Account ID" value={lead?.Account_ID} />
                <LeadField label="Account Name" value={lead?.Account_Name} />
                <LeadField label="Product" value={lead?.Product} />
                <LeadField label="Account Site" value={lead?.Account_Site} />
                <LeadField label="Account Number" value={lead?.Account_Number} />
                <LeadField label="Account Type" value={lead?.Account_Type} />
                <LeadField label="Industry" value={lead?.Industry} />
                <LeadField label="Annual Revenue" value={lead?.Annual_Revenue} />
                <LeadField label="Currency" value={lead?.Currency} />
                <LeadField label="Email" value={lead?.Email} />
                <LeadField label="Service" value={lead?.Service} />
                <LeadField label="PAN Number" value={lead?.tallyconnectormodules__Pan_Number} />
                <LeadField label="Bill Credit Period" value={lead?.Bill_Credit_Period} />
                <LeadField label="D.O.B" value={lead?.D_O_B} />
                <LeadField label="GST Number" value={lead?.tallyconnectormodules__GST_Number} />
                <LeadField label="Sync Status" value={lead?.Sync_Status} />
              </div>

              {/* Right Column */}
              <div className="lead-column">
                <LeadField label="Phone" value={lead?.Phone} />
                <LeadField label="Access Code" value={lead?.Access_Code} />
                <LeadField label="Fax" value={lead?.Fax} />
                <LeadField label="Website" value={lead?.Website} />
                <LeadField label="Ticker Symbol" value={lead?.Ticker_Symbol} />
                <LeadField label="Ownership" value={lead?.Ownership} />
                <LeadField label="Employees" value={lead?.Employees} />
                <LeadField label="SIC Code" value={lead?.SIC_Code} />
                <LeadField label="Exchange Rate" value={lead?.Exchange_Rate} />
                <LeadField label="Tally UID" value={lead?.tallyconnectormodules__Tally_UID} />



                {/* Created & Modified Details */}

              </div>
            </div>
          )}




          <h3 className="lead-title">Address Information</h3>
          <hr className="lead-divider" />
          {lead && (
            <div className="lead-details">
              {/* Left Column */}
              <div className="lead-column">
                <LeadField label="Billing Street" value={lead?.Billing_Street} />
                <LeadField label="Billing City" value={lead?.Billing_City} />
                <LeadField label="Billing State" value={lead?.Billing_State} />
                <LeadField label="Billing Code" value={lead?.Billing_Code} />
                <LeadField label="Billing Country" value={lead?.Billing_Country} />
              </div>

              {/* Right Column */}
              <div className="lead-column">


                {/* Billing Fields */}


                {/* Shipping Fields */}
                <LeadField label="Shipping Street" value={lead?.Shipping_Street} />
                <LeadField label="Shipping City" value={lead?.Shipping_City} />
                <LeadField label="Shipping State" value={lead?.Shipping_State} />
                <LeadField label="Shipping Code" value={lead?.Shipping_Code} />
                <LeadField label="Shipping Country" value={lead?.Shipping_Country} />


              </div>
            </div>
          )}
        </div>






       

      </div>

    )


  );
};

export default OrderDetail;
